// The Six Foundations — each is its own chapter with a dedicated page.
// Order matches the `home.foundations` and `foundationPages.items` locale arrays.
const IMG = "https://images.unsplash.com/";
const q = "?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600";

export const FOUNDATIONS = [
  { slug: "human-flourishing",        image: `${IMG}photo-1768345757674-fb0dcc36a6fb${q}`, article: "art-human-flourishing" },
  { slug: "health-lifestyle-medicine", image: `https://images.pexels.com/photos/1571939/pexels-photo-1571939.jpeg?auto=compress&cs=tinysrgb&w=1600`, article: "art-lifestyle-medicine" },
  { slug: "wisdom-lifelong-learning",  image: `${IMG}photo-1764214191022-2732e1fb79cf${q}`, article: "art-lifelong-learning" },
  { slug: "beauty-culture-environment",image: `${IMG}photo-1610238115511-81be15284155${q}`, article: "art-beauty-culture" },
  { slug: "technology-human-potential",image: `${IMG}photo-1741699427768-fbb97fc21425${q}`, article: "art-technology" },
  { slug: "character-purpose",         image: `${IMG}photo-1759097247817-7611910ae819${q}`, article: "art-character-purpose" },
];

export const foundationIndex = (slug) => FOUNDATIONS.findIndex((f) => f.slug === slug);
